<div class="modal-header">
  <h5 class="modal-title">Shipment Detail</h5>
  <!--  <a class="close p-0 btn btn-link" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </a>-->
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="detail mb-3">
    <div class="row">
      <div class="col">
        <b>
          Tracking Code:
        </b>
      </div>
      <div class="col">
        <a [href]="shipment.link">
          {{ shipment.tracking_code || 'N/A' }}
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b>
          Tracking Link:
        </b>
      </div>
      <div class="col">
        <a [href]="shipment.link" target="_blank">
          {{ shipment.link }}
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b>Date Shipped:</b>
      </div>
      <div class="col">
        {{ shipment.shipped_at | date:'MMM d, y':'utc' }}
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b>Expected Arrival:</b>
      </div>
      <div class="col">
        {{ shipment.arrives_at | date:'MMM d, y':'utc' }}
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b>Created At:</b>
      </div>
      <div class="col">
        {{ shipment.created_at | date:'MMM d, y':'utc'  }}
      </div>
    </div>
    <div class="row" *ngIf="shipment.created_by_name">
      <div class="col">
        <b>Created By:</b>
      </div>
      <div class="col">
        {{ shipment.created_by_name }}
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-around mb-2" *ngIf="shipment.file as shipmentFile">
    <div>
      <i class="fa fa-paperclip"></i>
    </div>
    <div class="d-flex flex-column text-center">
      <a (click)="getFile(shipmentFile.file)">
        {{ shipmentFile.file.file_name }}
      </a>
      {{ shipmentFile.file.file_size | fileSize }}
    </div>
    <div *ngIf="companyType === 'supplier'">
      <a (click)="deleteFile(shipmentFile.file)" matTooltip="Delete file">
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>


  <table class="table table-bordered">
    <thead>
    <tr>
      <th>Product Name</th>
      <th>Quantity Shipped</th>
      <th>Shipped to Date</th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let product of shipment.line_items">
      <td>
        {{ product.name }}
      </td>
      <td>
        {{ product.quantity_shipped }}
      </td>
      <td>
        {{ product.total_shipped_to_date }}
      </td>
    </tr>
    </tbody>
  </table>

  <div class="jumbotron p-2">
    {{ shipment.description }}
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-danger" (click)="activeModal.dismiss()">
    Close
  </button>
</div>
